import { CvDataCollection } from './cvDataCollection';
import { PlaceholderCvDataCollection } from './placeholderCvDataCollection';
import { RealApiCvDataCollection } from './realApiCvDataCollection';

const SOURCE_PLACEHOLDER = 'placeholder';
const SOURCE_REAL = 'real';

type DataSourceType = typeof SOURCE_PLACEHOLDER | typeof SOURCE_REAL;

const resolveDataSource = (): DataSourceType => {
  const configured = (process.env.REACT_APP_CV_DATA_SOURCE || '').toLowerCase();
  return configured === SOURCE_REAL ? SOURCE_REAL : SOURCE_PLACEHOLDER;
};

export const createCvDataCollection = (): CvDataCollection => {
  const source = resolveDataSource();

  if (source === SOURCE_REAL) {
    return new RealApiCvDataCollection(process.env.REACT_APP_API_BASE_URL || '/api/v1');
  }

  return new PlaceholderCvDataCollection();
};

export const cvDataCollection = createCvDataCollection();
